export default "__VITE_ASSET__CQtgnt8x__"